export default function deleteEcheancierAndReference(devis) {
  devis.echeanciers = [];
  devis.lignesCommande.forEach((ligne) => {
    ligne.referenceEcheancier = null;
    if (ligne.lignesCommande) {
      ligne.lignesCommande.forEach((ligneEnfant) => {
        ligneEnfant.referenceEcheancier = null;
      });
    }
  });
}
